import { render, staticRenderFns } from "./CampaignsReport.vue?vue&type=template&id=43d557c4&scoped=true&lang=pug"
import script from "./CampaignsReport.vue?vue&type=script&lang=js"
export * from "./CampaignsReport.vue?vue&type=script&lang=js"
import style0 from "./CampaignsReport.vue?vue&type=style&index=0&id=43d557c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d557c4",
  null
  
)

export default component.exports